import ApiServices from "./ApiServices";
import gql from "graphql-tag";

export default class ChatService extends ApiServices {
    constructor(credential = 'include') {
        super('/api/v1/chat/', credential);
    }

    async searchChat(search) {
        return await this.apolloClass.query({
            query: gql`
        query getChats($search: String!){
          chats_list_search(search: $search){
            chats{
              id, title, thumbnail, datetime_start_format, datetime_end_format, externallink
            }
          }
        }
      `,
            variables: {
                search
            },
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/ChatService.js